<script>
import TextField from "./text-field.vue";
import {
    translations
} from "../administration/user/data/variables";

export default {
    name: "password-fields",
    components: {TextField},
    props: {
        password: String,
        passwordConfirmation: String,
        asColumn: Boolean
    },
    data() {
        return {
            showPw: false
        }
    },
    computed: {
        translations() {
            return translations
        },
        isMatching() {
            return this.password === this.passwordConfirmation;
        },
        isLongEnough() {
            return this.password.length >= 8 || this.passwordConfirmation.length >= 8;
        },
        isComplexEnough() {
            const regEx = new RegExp(/^(?=.*[A-Za-z])(?=.*\d).{8,}$/);
            return regEx.test(this.password) && regEx.test(this.passwordConfirmation);
        },
        isValid() {
            // no passwords are always valid
            if (!this.password && !this.passwordConfirmation) {
                return true;
            }
            return this.isMatching && this.isLongEnough && this.isComplexEnough;
        },
        errorMessage() {
            if (this.isValid) return null;
            if (!this.isMatching) return Lang.langGet('Passwords do not match!');
            if (!this.isLongEnough) return Lang.langGet('The password must be at least 8 characters long.');
            if (!this.isComplexEnough) return Lang.langGet('The password must contain at least one character (A-Z, a-z) and at least one number (0-9).');
        },
    }
}
</script>

<template>
    <div v-if="asColumn">
        <div class="password-fields-column-container">
            <text-field
                @input="value => $emit('input', 'password', value, isValid)"
                :value="password"
                :label="translations.t_password"
                :type="showPw ? 'text' : 'password'"
                :error="!isValid"
                :errorMessage="errorMessage"
                :append-icon="showPw ? 'mdi-eye' : 'mdi-eye-off'"
                @click:append="showPw = !showPw"
                name="password"
            />
            <text-field
                @input="value => $emit('input', 'passwordConfirmation', value, isValid)"
                :value="passwordConfirmation"
                :label="translations.t_confirm"
                :type="showPw ? 'text' : 'password'"
                :error="!isValid"
                :errorMessage="errorMessage"
                :append-icon="showPw ? 'mdi-eye' : 'mdi-eye-off'"
                @click:append="showPw = !showPw"
                name="password_confirmation"
            />
        </div>
        <div class="password-fields-error-message">
            {{ errorMessage }}
        </div>
    </div>
    <div v-else class="d-flex flex-row w-100">
        <div class="d-flex flex-column w-50 pa-2">
            <text-field
                @input="value => $emit('input', 'password', value, isValid)"
                :value="password"
                :label="translations.t_password"
                :type="showPw ? 'text' : 'password'"
                :error="!isValid"
                :errorMessage="errorMessage"
                :append-icon="showPw ? 'mdi-eye' : 'mdi-eye-off'"
                :autocomplete="'one-time-code'"
                @click:append="showPw = !showPw"
            />
        </div>
        <div class="d-flex flex-column w-50 pa-2">
            <text-field
                @input="value => $emit('input', 'passwordConfirmation', value, isValid)"
                :value="passwordConfirmation"
                :label="translations.t_confirm"
                :type="showPw ? 'text' : 'password'"
                :error="!isValid"
                :errorMessage="errorMessage"
                :append-icon="showPw ? 'mdi-eye' : 'mdi-eye-off'"
                :autocomplete="'one-time-code'"
                @click:append="showPw = !showPw"
            />
        </div>
    </div>
</template>

<style scoped>
.password-fields-column-container {
    display: flex;
    flex-direction: column;
    gap: 12px
}
.password-fields-error-message {
    min-height: 26px;
    color: var(--color-error-text);
    visibility: hidden;
}

.password-fields-error-message:not(:empty) {
    visibility: visible;
}
</style>
